import React, { useState } from 'react';
import { ChevronDown } from 'react-bootstrap-icons';

/**
 * Collapsible group for header / mobile overflow menus.
 *
 * @param {string} title — Section heading (shown on the toggle row).
 * @param {boolean} [defaultOpen=true] — Initial expanded state.
 * @param {object} colors — Theme colors from useTheme() ({ borderLight, textLight, textMuted }).
 * @param {React.ReactNode} children — Links and buttons rendered when expanded.
 * @param {boolean} [isFirst=false] — When true, omit the top divider (first block after email header).
 */
export function MenuCollapsibleSection({
  title,
  defaultOpen = true,
  colors,
  children,
  isFirst = false,
  titleStyle,
  headerTrailing,
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <>
      {!isFirst ? (
        <div style={{ borderTop: `1px solid ${colors.borderLight}`, margin: '4px 0' }} role="presentation" />
      ) : null}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          paddingRight: headerTrailing ? 8 : 0,
        }}
      >
        <button
          type="button"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
          style={{
            padding: '8px 12px',
            flex: 1,
            minWidth: 0,
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            background: 'transparent',
            border: 'none',
            borderRadius: 0,
            color: colors.textLight,
            fontSize: '11px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'left',
            cursor: 'pointer',
            ...titleStyle,
          }}
        >
          <span>{title}</span>
          <ChevronDown
            size={14}
            style={{
              color: colors.textMuted,
              transition: 'transform 0.15s ease',
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
              flexShrink: 0,
            }}
            aria-hidden
          />
        </button>
        {headerTrailing ? (
          <div style={{ flexShrink: 0, paddingBottom: 2 }}>{headerTrailing}</div>
        ) : null}
      </div>
      {open ? (
        <div style={{ width: '100%', overflow: 'hidden', boxSizing: 'border-box' }}>{children}</div>
      ) : null}
    </>
  );
}
